
export class GetFundRangeFundSurveyCommand {
  constructor(
    public fundId: string,
    public valueAssessmentId: string
  ) { }
}
